export class SiteContentModel{
    constructor(){
    }
}